import viagsApiDev from "../../chats/api/axiosClientdev";
import { InfoMine } from "../types/user";

export const userApi = {
  getInfoMine: async () => {
    const response = await viagsApiDev.get<InfoMine>("/api/accounts/get-info-mine");
    return response.data;
  },
};
